// source: orderTransaction.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js');
goog.object.extend(proto, google_protobuf_wrappers_pb);
var Protos_common_pb = require('./common_pb.js');
goog.object.extend(proto, Protos_common_pb);
goog.exportSymbol('proto.order_transaction_endpoint.GetOrderTransactionReplay', null, global);
goog.exportSymbol('proto.order_transaction_endpoint.GetOrderTransactionRequest', null, global);
goog.exportSymbol('proto.order_transaction_endpoint.GetOrderTransactionResponse', null, global);
goog.exportSymbol('proto.order_transaction_endpoint.GetOrderTransactionResponse.ResultCase', null, global);
goog.exportSymbol('proto.order_transaction_endpoint.GetOrderTransactionsReplay', null, global);
goog.exportSymbol('proto.order_transaction_endpoint.GetOrderTransactionsRequest', null, global);
goog.exportSymbol('proto.order_transaction_endpoint.GetOrderTransactionsResponse', null, global);
goog.exportSymbol('proto.order_transaction_endpoint.GetOrderTransactionsResponse.ResultCase', null, global);
goog.exportSymbol('proto.order_transaction_endpoint.OrderTransaction', null, global);
goog.exportSymbol('proto.order_transaction_endpoint.OrderTransactionStatus', null, global);
goog.exportSymbol('proto.order_transaction_endpoint.UpdateOrderTransactionReplay', null, global);
goog.exportSymbol('proto.order_transaction_endpoint.UpdateOrderTransactionRequest', null, global);
goog.exportSymbol('proto.order_transaction_endpoint.UpdateOrderTransactionResponse', null, global);
goog.exportSymbol('proto.order_transaction_endpoint.UpdateOrderTransactionResponse.ResultCase', null, global);
goog.exportSymbol('proto.order_transaction_endpoint.UpdateOrderTransactionStateReplay', null, global);
goog.exportSymbol('proto.order_transaction_endpoint.UpdateOrderTransactionStateRequest', null, global);
goog.exportSymbol('proto.order_transaction_endpoint.UpdateOrderTransactionStateResponse', null, global);
goog.exportSymbol('proto.order_transaction_endpoint.UpdateOrderTransactionStateResponse.ResultCase', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.order_transaction_endpoint.UpdateOrderTransactionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.order_transaction_endpoint.UpdateOrderTransactionRequest.repeatedFields_, null);
};
goog.inherits(proto.order_transaction_endpoint.UpdateOrderTransactionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.order_transaction_endpoint.UpdateOrderTransactionRequest.displayName = 'proto.order_transaction_endpoint.UpdateOrderTransactionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.order_transaction_endpoint.UpdateOrderTransactionStateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.order_transaction_endpoint.UpdateOrderTransactionStateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.order_transaction_endpoint.UpdateOrderTransactionStateRequest.displayName = 'proto.order_transaction_endpoint.UpdateOrderTransactionStateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.order_transaction_endpoint.GetOrderTransactionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.order_transaction_endpoint.GetOrderTransactionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.order_transaction_endpoint.GetOrderTransactionRequest.displayName = 'proto.order_transaction_endpoint.GetOrderTransactionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.order_transaction_endpoint.GetOrderTransactionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.order_transaction_endpoint.GetOrderTransactionsRequest.displayName = 'proto.order_transaction_endpoint.GetOrderTransactionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.order_transaction_endpoint.OrderTransactionStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.order_transaction_endpoint.OrderTransactionStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.order_transaction_endpoint.OrderTransactionStatus.displayName = 'proto.order_transaction_endpoint.OrderTransactionStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.order_transaction_endpoint.GetOrderTransactionReplay.repeatedFields_, null);
};
goog.inherits(proto.order_transaction_endpoint.GetOrderTransactionReplay, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.order_transaction_endpoint.GetOrderTransactionReplay.displayName = 'proto.order_transaction_endpoint.GetOrderTransactionReplay';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.order_transaction_endpoint.OrderTransaction = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.order_transaction_endpoint.OrderTransaction.repeatedFields_, null);
};
goog.inherits(proto.order_transaction_endpoint.OrderTransaction, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.order_transaction_endpoint.OrderTransaction.displayName = 'proto.order_transaction_endpoint.OrderTransaction';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.order_transaction_endpoint.GetOrderTransactionsReplay = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.order_transaction_endpoint.GetOrderTransactionsReplay.repeatedFields_, null);
};
goog.inherits(proto.order_transaction_endpoint.GetOrderTransactionsReplay, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.order_transaction_endpoint.GetOrderTransactionsReplay.displayName = 'proto.order_transaction_endpoint.GetOrderTransactionsReplay';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.order_transaction_endpoint.UpdateOrderTransactionReplay = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.order_transaction_endpoint.UpdateOrderTransactionReplay, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.order_transaction_endpoint.UpdateOrderTransactionReplay.displayName = 'proto.order_transaction_endpoint.UpdateOrderTransactionReplay';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.order_transaction_endpoint.UpdateOrderTransactionStateReplay = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.order_transaction_endpoint.UpdateOrderTransactionStateReplay, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.order_transaction_endpoint.UpdateOrderTransactionStateReplay.displayName = 'proto.order_transaction_endpoint.UpdateOrderTransactionStateReplay';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.order_transaction_endpoint.GetOrderTransactionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.order_transaction_endpoint.GetOrderTransactionsResponse.oneofGroups_);
};
goog.inherits(proto.order_transaction_endpoint.GetOrderTransactionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.order_transaction_endpoint.GetOrderTransactionsResponse.displayName = 'proto.order_transaction_endpoint.GetOrderTransactionsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.order_transaction_endpoint.GetOrderTransactionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.order_transaction_endpoint.GetOrderTransactionResponse.oneofGroups_);
};
goog.inherits(proto.order_transaction_endpoint.GetOrderTransactionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.order_transaction_endpoint.GetOrderTransactionResponse.displayName = 'proto.order_transaction_endpoint.GetOrderTransactionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.order_transaction_endpoint.UpdateOrderTransactionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.order_transaction_endpoint.UpdateOrderTransactionResponse.oneofGroups_);
};
goog.inherits(proto.order_transaction_endpoint.UpdateOrderTransactionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.order_transaction_endpoint.UpdateOrderTransactionResponse.displayName = 'proto.order_transaction_endpoint.UpdateOrderTransactionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.order_transaction_endpoint.UpdateOrderTransactionStateResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.order_transaction_endpoint.UpdateOrderTransactionStateResponse.oneofGroups_);
};
goog.inherits(proto.order_transaction_endpoint.UpdateOrderTransactionStateResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.order_transaction_endpoint.UpdateOrderTransactionStateResponse.displayName = 'proto.order_transaction_endpoint.UpdateOrderTransactionStateResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.order_transaction_endpoint.UpdateOrderTransactionRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.order_transaction_endpoint.UpdateOrderTransactionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.order_transaction_endpoint.UpdateOrderTransactionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.order_transaction_endpoint.UpdateOrderTransactionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_transaction_endpoint.UpdateOrderTransactionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
extrafieldsList: jspb.Message.toObjectList(msg.getExtrafieldsList(),
    Protos_common_pb.ExtraField.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.order_transaction_endpoint.UpdateOrderTransactionRequest}
 */
proto.order_transaction_endpoint.UpdateOrderTransactionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.order_transaction_endpoint.UpdateOrderTransactionRequest;
  return proto.order_transaction_endpoint.UpdateOrderTransactionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.order_transaction_endpoint.UpdateOrderTransactionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.order_transaction_endpoint.UpdateOrderTransactionRequest}
 */
proto.order_transaction_endpoint.UpdateOrderTransactionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setId(value);
      break;
    case 2:
      var value = new Protos_common_pb.ExtraField;
      reader.readMessage(value,Protos_common_pb.ExtraField.deserializeBinaryFromReader);
      msg.addExtrafields(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.order_transaction_endpoint.UpdateOrderTransactionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.order_transaction_endpoint.UpdateOrderTransactionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.order_transaction_endpoint.UpdateOrderTransactionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_transaction_endpoint.UpdateOrderTransactionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getExtrafieldsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      Protos_common_pb.ExtraField.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.order_transaction_endpoint.UpdateOrderTransactionRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_transaction_endpoint.UpdateOrderTransactionRequest} returns this
 */
proto.order_transaction_endpoint.UpdateOrderTransactionRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated common.ExtraField extraFields = 2;
 * @return {!Array<!proto.common.ExtraField>}
 */
proto.order_transaction_endpoint.UpdateOrderTransactionRequest.prototype.getExtrafieldsList = function() {
  return /** @type{!Array<!proto.common.ExtraField>} */ (
    jspb.Message.getRepeatedWrapperField(this, Protos_common_pb.ExtraField, 2));
};


/**
 * @param {!Array<!proto.common.ExtraField>} value
 * @return {!proto.order_transaction_endpoint.UpdateOrderTransactionRequest} returns this
*/
proto.order_transaction_endpoint.UpdateOrderTransactionRequest.prototype.setExtrafieldsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.common.ExtraField=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.ExtraField}
 */
proto.order_transaction_endpoint.UpdateOrderTransactionRequest.prototype.addExtrafields = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.common.ExtraField, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.order_transaction_endpoint.UpdateOrderTransactionRequest} returns this
 */
proto.order_transaction_endpoint.UpdateOrderTransactionRequest.prototype.clearExtrafieldsList = function() {
  return this.setExtrafieldsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.order_transaction_endpoint.UpdateOrderTransactionStateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.order_transaction_endpoint.UpdateOrderTransactionStateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.order_transaction_endpoint.UpdateOrderTransactionStateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_transaction_endpoint.UpdateOrderTransactionStateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
status: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.order_transaction_endpoint.UpdateOrderTransactionStateRequest}
 */
proto.order_transaction_endpoint.UpdateOrderTransactionStateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.order_transaction_endpoint.UpdateOrderTransactionStateRequest;
  return proto.order_transaction_endpoint.UpdateOrderTransactionStateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.order_transaction_endpoint.UpdateOrderTransactionStateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.order_transaction_endpoint.UpdateOrderTransactionStateRequest}
 */
proto.order_transaction_endpoint.UpdateOrderTransactionStateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.order_transaction_endpoint.UpdateOrderTransactionStateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.order_transaction_endpoint.UpdateOrderTransactionStateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.order_transaction_endpoint.UpdateOrderTransactionStateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_transaction_endpoint.UpdateOrderTransactionStateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.order_transaction_endpoint.UpdateOrderTransactionStateRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_transaction_endpoint.UpdateOrderTransactionStateRequest} returns this
 */
proto.order_transaction_endpoint.UpdateOrderTransactionStateRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 status = 2;
 * @return {number}
 */
proto.order_transaction_endpoint.UpdateOrderTransactionStateRequest.prototype.getStatus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_transaction_endpoint.UpdateOrderTransactionStateRequest} returns this
 */
proto.order_transaction_endpoint.UpdateOrderTransactionStateRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.order_transaction_endpoint.GetOrderTransactionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.order_transaction_endpoint.GetOrderTransactionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.order_transaction_endpoint.GetOrderTransactionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_transaction_endpoint.GetOrderTransactionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionRequest}
 */
proto.order_transaction_endpoint.GetOrderTransactionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.order_transaction_endpoint.GetOrderTransactionRequest;
  return proto.order_transaction_endpoint.GetOrderTransactionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.order_transaction_endpoint.GetOrderTransactionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionRequest}
 */
proto.order_transaction_endpoint.GetOrderTransactionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.order_transaction_endpoint.GetOrderTransactionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.order_transaction_endpoint.GetOrderTransactionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.order_transaction_endpoint.GetOrderTransactionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_transaction_endpoint.GetOrderTransactionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.order_transaction_endpoint.GetOrderTransactionRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionRequest} returns this
 */
proto.order_transaction_endpoint.GetOrderTransactionRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.order_transaction_endpoint.GetOrderTransactionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.order_transaction_endpoint.GetOrderTransactionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
organization: (f = msg.getOrganization()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
orderid: (f = msg.getOrderid()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
from: (f = msg.getFrom()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
to: (f = msg.getTo()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
referenceorder: (f = msg.getReferenceorder()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
client: (f = msg.getClient()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
search: (f = msg.getSearch()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
order: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
nextto: (f = msg.getNextto()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
numofresults: jspb.Message.getFieldWithDefault(msg, 10, 0),
currency: (f = msg.getCurrency()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
fromaccount: (f = msg.getFromaccount()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
toaccount: (f = msg.getToaccount()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
referencetransaction: (f = msg.getReferencetransaction()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
matchtransaction: (f = msg.getMatchtransaction()) && google_protobuf_wrappers_pb.Int64Value.toObject(includeInstance, f),
status: (f = msg.getStatus()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
currencypair: (f = msg.getCurrencypair()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionsRequest}
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.order_transaction_endpoint.GetOrderTransactionsRequest;
  return proto.order_transaction_endpoint.GetOrderTransactionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.order_transaction_endpoint.GetOrderTransactionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionsRequest}
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setOrganization(value);
      break;
    case 2:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setOrderid(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setFrom(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTo(value);
      break;
    case 5:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setReferenceorder(value);
      break;
    case 6:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setClient(value);
      break;
    case 7:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setSearch(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOrder(value);
      break;
    case 9:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setNextto(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumofresults(value);
      break;
    case 11:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCurrency(value);
      break;
    case 12:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setFromaccount(value);
      break;
    case 13:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setToaccount(value);
      break;
    case 14:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setReferencetransaction(value);
      break;
    case 15:
      var value = new google_protobuf_wrappers_pb.Int64Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int64Value.deserializeBinaryFromReader);
      msg.setMatchtransaction(value);
      break;
    case 16:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setStatus(value);
      break;
    case 17:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setCurrencypair(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.order_transaction_endpoint.GetOrderTransactionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.order_transaction_endpoint.GetOrderTransactionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrganization();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getOrderid();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getFrom();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTo();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getReferenceorder();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getClient();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getSearch();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getOrder();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getNextto();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getNumofresults();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getCurrency();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getFromaccount();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getToaccount();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getReferencetransaction();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getMatchtransaction();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_protobuf_wrappers_pb.Int64Value.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getCurrencypair();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Int32Value organization = 1;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.getOrganization = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 1));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionsRequest} returns this
*/
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.setOrganization = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionsRequest} returns this
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.clearOrganization = function() {
  return this.setOrganization(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.hasOrganization = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.StringValue orderId = 2;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.getOrderid = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 2));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionsRequest} returns this
*/
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.setOrderid = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionsRequest} returns this
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.clearOrderid = function() {
  return this.setOrderid(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.hasOrderid = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp from = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.getFrom = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionsRequest} returns this
*/
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.setFrom = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionsRequest} returns this
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.clearFrom = function() {
  return this.setFrom(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.hasFrom = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Timestamp to = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.getTo = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionsRequest} returns this
*/
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.setTo = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionsRequest} returns this
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.clearTo = function() {
  return this.setTo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.hasTo = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.StringValue referenceOrder = 5;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.getReferenceorder = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 5));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionsRequest} returns this
*/
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.setReferenceorder = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionsRequest} returns this
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.clearReferenceorder = function() {
  return this.setReferenceorder(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.hasReferenceorder = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.StringValue client = 6;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.getClient = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 6));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionsRequest} returns this
*/
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.setClient = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionsRequest} returns this
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.clearClient = function() {
  return this.setClient(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.hasClient = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional google.protobuf.StringValue search = 7;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.getSearch = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 7));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionsRequest} returns this
*/
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.setSearch = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionsRequest} returns this
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.clearSearch = function() {
  return this.setSearch(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.hasSearch = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional bool order = 8;
 * @return {boolean}
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.getOrder = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionsRequest} returns this
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.setOrder = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional google.protobuf.StringValue nextTo = 9;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.getNextto = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 9));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionsRequest} returns this
*/
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.setNextto = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionsRequest} returns this
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.clearNextto = function() {
  return this.setNextto(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.hasNextto = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional int32 numOfResults = 10;
 * @return {number}
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.getNumofresults = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionsRequest} returns this
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.setNumofresults = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional google.protobuf.StringValue currency = 11;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.getCurrency = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 11));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionsRequest} returns this
*/
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.setCurrency = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionsRequest} returns this
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.clearCurrency = function() {
  return this.setCurrency(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.hasCurrency = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional google.protobuf.StringValue fromAccount = 12;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.getFromaccount = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 12));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionsRequest} returns this
*/
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.setFromaccount = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionsRequest} returns this
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.clearFromaccount = function() {
  return this.setFromaccount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.hasFromaccount = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional google.protobuf.StringValue toAccount = 13;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.getToaccount = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 13));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionsRequest} returns this
*/
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.setToaccount = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionsRequest} returns this
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.clearToaccount = function() {
  return this.setToaccount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.hasToaccount = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional google.protobuf.Int64Value referenceTransaction = 14;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.getReferencetransaction = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 14));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionsRequest} returns this
*/
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.setReferencetransaction = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionsRequest} returns this
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.clearReferencetransaction = function() {
  return this.setReferencetransaction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.hasReferencetransaction = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional google.protobuf.Int64Value matchTransaction = 15;
 * @return {?proto.google.protobuf.Int64Value}
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.getMatchtransaction = function() {
  return /** @type{?proto.google.protobuf.Int64Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int64Value, 15));
};


/**
 * @param {?proto.google.protobuf.Int64Value|undefined} value
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionsRequest} returns this
*/
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.setMatchtransaction = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionsRequest} returns this
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.clearMatchtransaction = function() {
  return this.setMatchtransaction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.hasMatchtransaction = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional google.protobuf.Int32Value status = 16;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.getStatus = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 16));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionsRequest} returns this
*/
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.setStatus = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionsRequest} returns this
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.clearStatus = function() {
  return this.setStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.hasStatus = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional google.protobuf.StringValue currencyPair = 17;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.getCurrencypair = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 17));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionsRequest} returns this
*/
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.setCurrencypair = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionsRequest} returns this
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.clearCurrencypair = function() {
  return this.setCurrencypair(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.GetOrderTransactionsRequest.prototype.hasCurrencypair = function() {
  return jspb.Message.getField(this, 17) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.order_transaction_endpoint.OrderTransactionStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.order_transaction_endpoint.OrderTransactionStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.order_transaction_endpoint.OrderTransactionStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_transaction_endpoint.OrderTransactionStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
id: (f = msg.getId()) && google_protobuf_wrappers_pb.Int32Value.toObject(includeInstance, f),
createdby: (f = msg.getCreatedby()) && Protos_common_pb.ProfileResponse.toObject(includeInstance, f),
createddate: (f = msg.getCreateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.order_transaction_endpoint.OrderTransactionStatus}
 */
proto.order_transaction_endpoint.OrderTransactionStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.order_transaction_endpoint.OrderTransactionStatus;
  return proto.order_transaction_endpoint.OrderTransactionStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.order_transaction_endpoint.OrderTransactionStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.order_transaction_endpoint.OrderTransactionStatus}
 */
proto.order_transaction_endpoint.OrderTransactionStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_wrappers_pb.Int32Value;
      reader.readMessage(value,google_protobuf_wrappers_pb.Int32Value.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 2:
      var value = new Protos_common_pb.ProfileResponse;
      reader.readMessage(value,Protos_common_pb.ProfileResponse.deserializeBinaryFromReader);
      msg.setCreatedby(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreateddate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.order_transaction_endpoint.OrderTransactionStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.order_transaction_endpoint.OrderTransactionStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.order_transaction_endpoint.OrderTransactionStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_transaction_endpoint.OrderTransactionStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_wrappers_pb.Int32Value.serializeBinaryToWriter
    );
  }
  f = message.getCreatedby();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      Protos_common_pb.ProfileResponse.serializeBinaryToWriter
    );
  }
  f = message.getCreateddate();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Int32Value id = 1;
 * @return {?proto.google.protobuf.Int32Value}
 */
proto.order_transaction_endpoint.OrderTransactionStatus.prototype.getId = function() {
  return /** @type{?proto.google.protobuf.Int32Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.Int32Value, 1));
};


/**
 * @param {?proto.google.protobuf.Int32Value|undefined} value
 * @return {!proto.order_transaction_endpoint.OrderTransactionStatus} returns this
*/
proto.order_transaction_endpoint.OrderTransactionStatus.prototype.setId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.OrderTransactionStatus} returns this
 */
proto.order_transaction_endpoint.OrderTransactionStatus.prototype.clearId = function() {
  return this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.OrderTransactionStatus.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional common.ProfileResponse createdBy = 2;
 * @return {?proto.common.ProfileResponse}
 */
proto.order_transaction_endpoint.OrderTransactionStatus.prototype.getCreatedby = function() {
  return /** @type{?proto.common.ProfileResponse} */ (
    jspb.Message.getWrapperField(this, Protos_common_pb.ProfileResponse, 2));
};


/**
 * @param {?proto.common.ProfileResponse|undefined} value
 * @return {!proto.order_transaction_endpoint.OrderTransactionStatus} returns this
*/
proto.order_transaction_endpoint.OrderTransactionStatus.prototype.setCreatedby = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.OrderTransactionStatus} returns this
 */
proto.order_transaction_endpoint.OrderTransactionStatus.prototype.clearCreatedby = function() {
  return this.setCreatedby(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.OrderTransactionStatus.prototype.hasCreatedby = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp createdDate = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.order_transaction_endpoint.OrderTransactionStatus.prototype.getCreateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.order_transaction_endpoint.OrderTransactionStatus} returns this
*/
proto.order_transaction_endpoint.OrderTransactionStatus.prototype.setCreateddate = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.OrderTransactionStatus} returns this
 */
proto.order_transaction_endpoint.OrderTransactionStatus.prototype.clearCreateddate = function() {
  return this.setCreateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.OrderTransactionStatus.prototype.hasCreateddate = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.repeatedFields_ = [14,16];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.toObject = function(opt_includeInstance) {
  return proto.order_transaction_endpoint.GetOrderTransactionReplay.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.order_transaction_endpoint.GetOrderTransactionReplay} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
order: (f = msg.getOrder()) && Protos_common_pb.OrderResponse.toObject(includeInstance, f),
amount: (f = msg.getAmount()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
fromaccount: (f = msg.getFromaccount()) && Protos_common_pb.AccountResponse.toObject(includeInstance, f),
toaccount: (f = msg.getToaccount()) && Protos_common_pb.AccountResponse.toObject(includeInstance, f),
referencetransaction: (f = msg.getReferencetransaction()) && Protos_common_pb.TransactionResponse.toObject(includeInstance, f),
referenceorder: (f = msg.getReferenceorder()) && Protos_common_pb.OrderResponse.toObject(includeInstance, f),
currency: (f = msg.getCurrency()) && Protos_common_pb.CurrencyResponse.toObject(includeInstance, f),
createddate: (f = msg.getCreateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
createdby: (f = msg.getCreatedby()) && Protos_common_pb.ProfileResponse.toObject(includeInstance, f),
client: (f = msg.getClient()) && Protos_common_pb.ProfileResponse.toObject(includeInstance, f),
matchtransaction: (f = msg.getMatchtransaction()) && Protos_common_pb.TransactionResponse.toObject(includeInstance, f),
status: (f = msg.getStatus()) && proto.order_transaction_endpoint.OrderTransactionStatus.toObject(includeInstance, f),
extrafieldsList: jspb.Message.toObjectList(msg.getExtrafieldsList(),
    Protos_common_pb.ExtraField.toObject, includeInstance),
tradeditem: (f = msg.getTradeditem()) && Protos_common_pb.OrderItemResponse.toObject(includeInstance, f),
attachmentsList: jspb.Message.toObjectList(msg.getAttachmentsList(),
    Protos_common_pb.ExtraField.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionReplay}
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.order_transaction_endpoint.GetOrderTransactionReplay;
  return proto.order_transaction_endpoint.GetOrderTransactionReplay.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.order_transaction_endpoint.GetOrderTransactionReplay} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionReplay}
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setId(value);
      break;
    case 2:
      var value = new Protos_common_pb.OrderResponse;
      reader.readMessage(value,Protos_common_pb.OrderResponse.deserializeBinaryFromReader);
      msg.setOrder(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAmount(value);
      break;
    case 4:
      var value = new Protos_common_pb.AccountResponse;
      reader.readMessage(value,Protos_common_pb.AccountResponse.deserializeBinaryFromReader);
      msg.setFromaccount(value);
      break;
    case 5:
      var value = new Protos_common_pb.AccountResponse;
      reader.readMessage(value,Protos_common_pb.AccountResponse.deserializeBinaryFromReader);
      msg.setToaccount(value);
      break;
    case 6:
      var value = new Protos_common_pb.TransactionResponse;
      reader.readMessage(value,Protos_common_pb.TransactionResponse.deserializeBinaryFromReader);
      msg.setReferencetransaction(value);
      break;
    case 7:
      var value = new Protos_common_pb.OrderResponse;
      reader.readMessage(value,Protos_common_pb.OrderResponse.deserializeBinaryFromReader);
      msg.setReferenceorder(value);
      break;
    case 8:
      var value = new Protos_common_pb.CurrencyResponse;
      reader.readMessage(value,Protos_common_pb.CurrencyResponse.deserializeBinaryFromReader);
      msg.setCurrency(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreateddate(value);
      break;
    case 10:
      var value = new Protos_common_pb.ProfileResponse;
      reader.readMessage(value,Protos_common_pb.ProfileResponse.deserializeBinaryFromReader);
      msg.setCreatedby(value);
      break;
    case 11:
      var value = new Protos_common_pb.ProfileResponse;
      reader.readMessage(value,Protos_common_pb.ProfileResponse.deserializeBinaryFromReader);
      msg.setClient(value);
      break;
    case 12:
      var value = new Protos_common_pb.TransactionResponse;
      reader.readMessage(value,Protos_common_pb.TransactionResponse.deserializeBinaryFromReader);
      msg.setMatchtransaction(value);
      break;
    case 13:
      var value = new proto.order_transaction_endpoint.OrderTransactionStatus;
      reader.readMessage(value,proto.order_transaction_endpoint.OrderTransactionStatus.deserializeBinaryFromReader);
      msg.setStatus(value);
      break;
    case 14:
      var value = new Protos_common_pb.ExtraField;
      reader.readMessage(value,Protos_common_pb.ExtraField.deserializeBinaryFromReader);
      msg.addExtrafields(value);
      break;
    case 15:
      var value = new Protos_common_pb.OrderItemResponse;
      reader.readMessage(value,Protos_common_pb.OrderItemResponse.deserializeBinaryFromReader);
      msg.setTradeditem(value);
      break;
    case 16:
      var value = new Protos_common_pb.ExtraField;
      reader.readMessage(value,Protos_common_pb.ExtraField.deserializeBinaryFromReader);
      msg.addAttachments(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.order_transaction_endpoint.GetOrderTransactionReplay.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.order_transaction_endpoint.GetOrderTransactionReplay} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOrder();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      Protos_common_pb.OrderResponse.serializeBinaryToWriter
    );
  }
  f = message.getAmount();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getFromaccount();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      Protos_common_pb.AccountResponse.serializeBinaryToWriter
    );
  }
  f = message.getToaccount();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      Protos_common_pb.AccountResponse.serializeBinaryToWriter
    );
  }
  f = message.getReferencetransaction();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      Protos_common_pb.TransactionResponse.serializeBinaryToWriter
    );
  }
  f = message.getReferenceorder();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      Protos_common_pb.OrderResponse.serializeBinaryToWriter
    );
  }
  f = message.getCurrency();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      Protos_common_pb.CurrencyResponse.serializeBinaryToWriter
    );
  }
  f = message.getCreateddate();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCreatedby();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      Protos_common_pb.ProfileResponse.serializeBinaryToWriter
    );
  }
  f = message.getClient();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      Protos_common_pb.ProfileResponse.serializeBinaryToWriter
    );
  }
  f = message.getMatchtransaction();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      Protos_common_pb.TransactionResponse.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.order_transaction_endpoint.OrderTransactionStatus.serializeBinaryToWriter
    );
  }
  f = message.getExtrafieldsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      14,
      f,
      Protos_common_pb.ExtraField.serializeBinaryToWriter
    );
  }
  f = message.getTradeditem();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      Protos_common_pb.OrderItemResponse.serializeBinaryToWriter
    );
  }
  f = message.getAttachmentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      16,
      f,
      Protos_common_pb.ExtraField.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionReplay} returns this
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional common.OrderResponse order = 2;
 * @return {?proto.common.OrderResponse}
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.getOrder = function() {
  return /** @type{?proto.common.OrderResponse} */ (
    jspb.Message.getWrapperField(this, Protos_common_pb.OrderResponse, 2));
};


/**
 * @param {?proto.common.OrderResponse|undefined} value
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionReplay} returns this
*/
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.setOrder = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionReplay} returns this
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.clearOrder = function() {
  return this.setOrder(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.hasOrder = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.StringValue amount = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.getAmount = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionReplay} returns this
*/
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.setAmount = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionReplay} returns this
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.clearAmount = function() {
  return this.setAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.hasAmount = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional common.AccountResponse fromAccount = 4;
 * @return {?proto.common.AccountResponse}
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.getFromaccount = function() {
  return /** @type{?proto.common.AccountResponse} */ (
    jspb.Message.getWrapperField(this, Protos_common_pb.AccountResponse, 4));
};


/**
 * @param {?proto.common.AccountResponse|undefined} value
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionReplay} returns this
*/
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.setFromaccount = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionReplay} returns this
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.clearFromaccount = function() {
  return this.setFromaccount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.hasFromaccount = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional common.AccountResponse toAccount = 5;
 * @return {?proto.common.AccountResponse}
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.getToaccount = function() {
  return /** @type{?proto.common.AccountResponse} */ (
    jspb.Message.getWrapperField(this, Protos_common_pb.AccountResponse, 5));
};


/**
 * @param {?proto.common.AccountResponse|undefined} value
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionReplay} returns this
*/
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.setToaccount = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionReplay} returns this
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.clearToaccount = function() {
  return this.setToaccount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.hasToaccount = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional common.TransactionResponse referenceTransaction = 6;
 * @return {?proto.common.TransactionResponse}
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.getReferencetransaction = function() {
  return /** @type{?proto.common.TransactionResponse} */ (
    jspb.Message.getWrapperField(this, Protos_common_pb.TransactionResponse, 6));
};


/**
 * @param {?proto.common.TransactionResponse|undefined} value
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionReplay} returns this
*/
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.setReferencetransaction = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionReplay} returns this
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.clearReferencetransaction = function() {
  return this.setReferencetransaction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.hasReferencetransaction = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional common.OrderResponse referenceOrder = 7;
 * @return {?proto.common.OrderResponse}
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.getReferenceorder = function() {
  return /** @type{?proto.common.OrderResponse} */ (
    jspb.Message.getWrapperField(this, Protos_common_pb.OrderResponse, 7));
};


/**
 * @param {?proto.common.OrderResponse|undefined} value
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionReplay} returns this
*/
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.setReferenceorder = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionReplay} returns this
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.clearReferenceorder = function() {
  return this.setReferenceorder(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.hasReferenceorder = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional common.CurrencyResponse currency = 8;
 * @return {?proto.common.CurrencyResponse}
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.getCurrency = function() {
  return /** @type{?proto.common.CurrencyResponse} */ (
    jspb.Message.getWrapperField(this, Protos_common_pb.CurrencyResponse, 8));
};


/**
 * @param {?proto.common.CurrencyResponse|undefined} value
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionReplay} returns this
*/
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.setCurrency = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionReplay} returns this
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.clearCurrency = function() {
  return this.setCurrency(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.hasCurrency = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.Timestamp createdDate = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.getCreateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionReplay} returns this
*/
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.setCreateddate = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionReplay} returns this
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.clearCreateddate = function() {
  return this.setCreateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.hasCreateddate = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional common.ProfileResponse createdBy = 10;
 * @return {?proto.common.ProfileResponse}
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.getCreatedby = function() {
  return /** @type{?proto.common.ProfileResponse} */ (
    jspb.Message.getWrapperField(this, Protos_common_pb.ProfileResponse, 10));
};


/**
 * @param {?proto.common.ProfileResponse|undefined} value
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionReplay} returns this
*/
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.setCreatedby = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionReplay} returns this
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.clearCreatedby = function() {
  return this.setCreatedby(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.hasCreatedby = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional common.ProfileResponse client = 11;
 * @return {?proto.common.ProfileResponse}
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.getClient = function() {
  return /** @type{?proto.common.ProfileResponse} */ (
    jspb.Message.getWrapperField(this, Protos_common_pb.ProfileResponse, 11));
};


/**
 * @param {?proto.common.ProfileResponse|undefined} value
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionReplay} returns this
*/
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.setClient = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionReplay} returns this
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.clearClient = function() {
  return this.setClient(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.hasClient = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional common.TransactionResponse matchTransaction = 12;
 * @return {?proto.common.TransactionResponse}
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.getMatchtransaction = function() {
  return /** @type{?proto.common.TransactionResponse} */ (
    jspb.Message.getWrapperField(this, Protos_common_pb.TransactionResponse, 12));
};


/**
 * @param {?proto.common.TransactionResponse|undefined} value
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionReplay} returns this
*/
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.setMatchtransaction = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionReplay} returns this
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.clearMatchtransaction = function() {
  return this.setMatchtransaction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.hasMatchtransaction = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional OrderTransactionStatus status = 13;
 * @return {?proto.order_transaction_endpoint.OrderTransactionStatus}
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.getStatus = function() {
  return /** @type{?proto.order_transaction_endpoint.OrderTransactionStatus} */ (
    jspb.Message.getWrapperField(this, proto.order_transaction_endpoint.OrderTransactionStatus, 13));
};


/**
 * @param {?proto.order_transaction_endpoint.OrderTransactionStatus|undefined} value
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionReplay} returns this
*/
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.setStatus = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionReplay} returns this
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.clearStatus = function() {
  return this.setStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.hasStatus = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * repeated common.ExtraField extraFields = 14;
 * @return {!Array<!proto.common.ExtraField>}
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.getExtrafieldsList = function() {
  return /** @type{!Array<!proto.common.ExtraField>} */ (
    jspb.Message.getRepeatedWrapperField(this, Protos_common_pb.ExtraField, 14));
};


/**
 * @param {!Array<!proto.common.ExtraField>} value
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionReplay} returns this
*/
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.setExtrafieldsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 14, value);
};


/**
 * @param {!proto.common.ExtraField=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.ExtraField}
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.addExtrafields = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 14, opt_value, proto.common.ExtraField, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionReplay} returns this
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.clearExtrafieldsList = function() {
  return this.setExtrafieldsList([]);
};


/**
 * optional common.OrderItemResponse tradedItem = 15;
 * @return {?proto.common.OrderItemResponse}
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.getTradeditem = function() {
  return /** @type{?proto.common.OrderItemResponse} */ (
    jspb.Message.getWrapperField(this, Protos_common_pb.OrderItemResponse, 15));
};


/**
 * @param {?proto.common.OrderItemResponse|undefined} value
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionReplay} returns this
*/
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.setTradeditem = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionReplay} returns this
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.clearTradeditem = function() {
  return this.setTradeditem(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.hasTradeditem = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * repeated common.ExtraField attachments = 16;
 * @return {!Array<!proto.common.ExtraField>}
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.getAttachmentsList = function() {
  return /** @type{!Array<!proto.common.ExtraField>} */ (
    jspb.Message.getRepeatedWrapperField(this, Protos_common_pb.ExtraField, 16));
};


/**
 * @param {!Array<!proto.common.ExtraField>} value
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionReplay} returns this
*/
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.setAttachmentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 16, value);
};


/**
 * @param {!proto.common.ExtraField=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.ExtraField}
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.addAttachments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 16, opt_value, proto.common.ExtraField, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionReplay} returns this
 */
proto.order_transaction_endpoint.GetOrderTransactionReplay.prototype.clearAttachmentsList = function() {
  return this.setAttachmentsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.order_transaction_endpoint.OrderTransaction.repeatedFields_ = [14];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.order_transaction_endpoint.OrderTransaction.prototype.toObject = function(opt_includeInstance) {
  return proto.order_transaction_endpoint.OrderTransaction.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.order_transaction_endpoint.OrderTransaction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_transaction_endpoint.OrderTransaction.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
order: (f = msg.getOrder()) && Protos_common_pb.OrderResponse.toObject(includeInstance, f),
amount: (f = msg.getAmount()) && google_protobuf_wrappers_pb.StringValue.toObject(includeInstance, f),
referencetransaction: (f = msg.getReferencetransaction()) && Protos_common_pb.TransactionResponse.toObject(includeInstance, f),
currency: (f = msg.getCurrency()) && Protos_common_pb.CurrencyResponse.toObject(includeInstance, f),
createddate: (f = msg.getCreateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
createdby: (f = msg.getCreatedby()) && Protos_common_pb.ProfileResponse.toObject(includeInstance, f),
client: (f = msg.getClient()) && Protos_common_pb.ProfileResponse.toObject(includeInstance, f),
referenceorder: (f = msg.getReferenceorder()) && Protos_common_pb.OrderResponse.toObject(includeInstance, f),
fromaccount: (f = msg.getFromaccount()) && Protos_common_pb.AccountResponse.toObject(includeInstance, f),
toaccount: (f = msg.getToaccount()) && Protos_common_pb.AccountResponse.toObject(includeInstance, f),
matchtransaction: (f = msg.getMatchtransaction()) && Protos_common_pb.TransactionResponse.toObject(includeInstance, f),
status: (f = msg.getStatus()) && proto.order_transaction_endpoint.OrderTransactionStatus.toObject(includeInstance, f),
extrafieldsList: jspb.Message.toObjectList(msg.getExtrafieldsList(),
    Protos_common_pb.ExtraField.toObject, includeInstance),
tradeditem: (f = msg.getTradeditem()) && Protos_common_pb.OrderItemResponse.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.order_transaction_endpoint.OrderTransaction}
 */
proto.order_transaction_endpoint.OrderTransaction.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.order_transaction_endpoint.OrderTransaction;
  return proto.order_transaction_endpoint.OrderTransaction.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.order_transaction_endpoint.OrderTransaction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.order_transaction_endpoint.OrderTransaction}
 */
proto.order_transaction_endpoint.OrderTransaction.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setId(value);
      break;
    case 2:
      var value = new Protos_common_pb.OrderResponse;
      reader.readMessage(value,Protos_common_pb.OrderResponse.deserializeBinaryFromReader);
      msg.setOrder(value);
      break;
    case 3:
      var value = new google_protobuf_wrappers_pb.StringValue;
      reader.readMessage(value,google_protobuf_wrappers_pb.StringValue.deserializeBinaryFromReader);
      msg.setAmount(value);
      break;
    case 4:
      var value = new Protos_common_pb.TransactionResponse;
      reader.readMessage(value,Protos_common_pb.TransactionResponse.deserializeBinaryFromReader);
      msg.setReferencetransaction(value);
      break;
    case 5:
      var value = new Protos_common_pb.CurrencyResponse;
      reader.readMessage(value,Protos_common_pb.CurrencyResponse.deserializeBinaryFromReader);
      msg.setCurrency(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreateddate(value);
      break;
    case 7:
      var value = new Protos_common_pb.ProfileResponse;
      reader.readMessage(value,Protos_common_pb.ProfileResponse.deserializeBinaryFromReader);
      msg.setCreatedby(value);
      break;
    case 8:
      var value = new Protos_common_pb.ProfileResponse;
      reader.readMessage(value,Protos_common_pb.ProfileResponse.deserializeBinaryFromReader);
      msg.setClient(value);
      break;
    case 9:
      var value = new Protos_common_pb.OrderResponse;
      reader.readMessage(value,Protos_common_pb.OrderResponse.deserializeBinaryFromReader);
      msg.setReferenceorder(value);
      break;
    case 10:
      var value = new Protos_common_pb.AccountResponse;
      reader.readMessage(value,Protos_common_pb.AccountResponse.deserializeBinaryFromReader);
      msg.setFromaccount(value);
      break;
    case 11:
      var value = new Protos_common_pb.AccountResponse;
      reader.readMessage(value,Protos_common_pb.AccountResponse.deserializeBinaryFromReader);
      msg.setToaccount(value);
      break;
    case 12:
      var value = new Protos_common_pb.TransactionResponse;
      reader.readMessage(value,Protos_common_pb.TransactionResponse.deserializeBinaryFromReader);
      msg.setMatchtransaction(value);
      break;
    case 13:
      var value = new proto.order_transaction_endpoint.OrderTransactionStatus;
      reader.readMessage(value,proto.order_transaction_endpoint.OrderTransactionStatus.deserializeBinaryFromReader);
      msg.setStatus(value);
      break;
    case 14:
      var value = new Protos_common_pb.ExtraField;
      reader.readMessage(value,Protos_common_pb.ExtraField.deserializeBinaryFromReader);
      msg.addExtrafields(value);
      break;
    case 15:
      var value = new Protos_common_pb.OrderItemResponse;
      reader.readMessage(value,Protos_common_pb.OrderItemResponse.deserializeBinaryFromReader);
      msg.setTradeditem(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.order_transaction_endpoint.OrderTransaction.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.order_transaction_endpoint.OrderTransaction.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.order_transaction_endpoint.OrderTransaction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_transaction_endpoint.OrderTransaction.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOrder();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      Protos_common_pb.OrderResponse.serializeBinaryToWriter
    );
  }
  f = message.getAmount();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_wrappers_pb.StringValue.serializeBinaryToWriter
    );
  }
  f = message.getReferencetransaction();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      Protos_common_pb.TransactionResponse.serializeBinaryToWriter
    );
  }
  f = message.getCurrency();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      Protos_common_pb.CurrencyResponse.serializeBinaryToWriter
    );
  }
  f = message.getCreateddate();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCreatedby();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      Protos_common_pb.ProfileResponse.serializeBinaryToWriter
    );
  }
  f = message.getClient();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      Protos_common_pb.ProfileResponse.serializeBinaryToWriter
    );
  }
  f = message.getReferenceorder();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      Protos_common_pb.OrderResponse.serializeBinaryToWriter
    );
  }
  f = message.getFromaccount();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      Protos_common_pb.AccountResponse.serializeBinaryToWriter
    );
  }
  f = message.getToaccount();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      Protos_common_pb.AccountResponse.serializeBinaryToWriter
    );
  }
  f = message.getMatchtransaction();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      Protos_common_pb.TransactionResponse.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.order_transaction_endpoint.OrderTransactionStatus.serializeBinaryToWriter
    );
  }
  f = message.getExtrafieldsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      14,
      f,
      Protos_common_pb.ExtraField.serializeBinaryToWriter
    );
  }
  f = message.getTradeditem();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      Protos_common_pb.OrderItemResponse.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.order_transaction_endpoint.OrderTransaction.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.order_transaction_endpoint.OrderTransaction} returns this
 */
proto.order_transaction_endpoint.OrderTransaction.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional common.OrderResponse order = 2;
 * @return {?proto.common.OrderResponse}
 */
proto.order_transaction_endpoint.OrderTransaction.prototype.getOrder = function() {
  return /** @type{?proto.common.OrderResponse} */ (
    jspb.Message.getWrapperField(this, Protos_common_pb.OrderResponse, 2));
};


/**
 * @param {?proto.common.OrderResponse|undefined} value
 * @return {!proto.order_transaction_endpoint.OrderTransaction} returns this
*/
proto.order_transaction_endpoint.OrderTransaction.prototype.setOrder = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.OrderTransaction} returns this
 */
proto.order_transaction_endpoint.OrderTransaction.prototype.clearOrder = function() {
  return this.setOrder(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.OrderTransaction.prototype.hasOrder = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.StringValue amount = 3;
 * @return {?proto.google.protobuf.StringValue}
 */
proto.order_transaction_endpoint.OrderTransaction.prototype.getAmount = function() {
  return /** @type{?proto.google.protobuf.StringValue} */ (
    jspb.Message.getWrapperField(this, google_protobuf_wrappers_pb.StringValue, 3));
};


/**
 * @param {?proto.google.protobuf.StringValue|undefined} value
 * @return {!proto.order_transaction_endpoint.OrderTransaction} returns this
*/
proto.order_transaction_endpoint.OrderTransaction.prototype.setAmount = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.OrderTransaction} returns this
 */
proto.order_transaction_endpoint.OrderTransaction.prototype.clearAmount = function() {
  return this.setAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.OrderTransaction.prototype.hasAmount = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional common.TransactionResponse referenceTransaction = 4;
 * @return {?proto.common.TransactionResponse}
 */
proto.order_transaction_endpoint.OrderTransaction.prototype.getReferencetransaction = function() {
  return /** @type{?proto.common.TransactionResponse} */ (
    jspb.Message.getWrapperField(this, Protos_common_pb.TransactionResponse, 4));
};


/**
 * @param {?proto.common.TransactionResponse|undefined} value
 * @return {!proto.order_transaction_endpoint.OrderTransaction} returns this
*/
proto.order_transaction_endpoint.OrderTransaction.prototype.setReferencetransaction = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.OrderTransaction} returns this
 */
proto.order_transaction_endpoint.OrderTransaction.prototype.clearReferencetransaction = function() {
  return this.setReferencetransaction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.OrderTransaction.prototype.hasReferencetransaction = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional common.CurrencyResponse currency = 5;
 * @return {?proto.common.CurrencyResponse}
 */
proto.order_transaction_endpoint.OrderTransaction.prototype.getCurrency = function() {
  return /** @type{?proto.common.CurrencyResponse} */ (
    jspb.Message.getWrapperField(this, Protos_common_pb.CurrencyResponse, 5));
};


/**
 * @param {?proto.common.CurrencyResponse|undefined} value
 * @return {!proto.order_transaction_endpoint.OrderTransaction} returns this
*/
proto.order_transaction_endpoint.OrderTransaction.prototype.setCurrency = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.OrderTransaction} returns this
 */
proto.order_transaction_endpoint.OrderTransaction.prototype.clearCurrency = function() {
  return this.setCurrency(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.OrderTransaction.prototype.hasCurrency = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.Timestamp createdDate = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.order_transaction_endpoint.OrderTransaction.prototype.getCreateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.order_transaction_endpoint.OrderTransaction} returns this
*/
proto.order_transaction_endpoint.OrderTransaction.prototype.setCreateddate = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.OrderTransaction} returns this
 */
proto.order_transaction_endpoint.OrderTransaction.prototype.clearCreateddate = function() {
  return this.setCreateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.OrderTransaction.prototype.hasCreateddate = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional common.ProfileResponse createdBy = 7;
 * @return {?proto.common.ProfileResponse}
 */
proto.order_transaction_endpoint.OrderTransaction.prototype.getCreatedby = function() {
  return /** @type{?proto.common.ProfileResponse} */ (
    jspb.Message.getWrapperField(this, Protos_common_pb.ProfileResponse, 7));
};


/**
 * @param {?proto.common.ProfileResponse|undefined} value
 * @return {!proto.order_transaction_endpoint.OrderTransaction} returns this
*/
proto.order_transaction_endpoint.OrderTransaction.prototype.setCreatedby = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.OrderTransaction} returns this
 */
proto.order_transaction_endpoint.OrderTransaction.prototype.clearCreatedby = function() {
  return this.setCreatedby(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.OrderTransaction.prototype.hasCreatedby = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional common.ProfileResponse client = 8;
 * @return {?proto.common.ProfileResponse}
 */
proto.order_transaction_endpoint.OrderTransaction.prototype.getClient = function() {
  return /** @type{?proto.common.ProfileResponse} */ (
    jspb.Message.getWrapperField(this, Protos_common_pb.ProfileResponse, 8));
};


/**
 * @param {?proto.common.ProfileResponse|undefined} value
 * @return {!proto.order_transaction_endpoint.OrderTransaction} returns this
*/
proto.order_transaction_endpoint.OrderTransaction.prototype.setClient = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.OrderTransaction} returns this
 */
proto.order_transaction_endpoint.OrderTransaction.prototype.clearClient = function() {
  return this.setClient(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.OrderTransaction.prototype.hasClient = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional common.OrderResponse referenceOrder = 9;
 * @return {?proto.common.OrderResponse}
 */
proto.order_transaction_endpoint.OrderTransaction.prototype.getReferenceorder = function() {
  return /** @type{?proto.common.OrderResponse} */ (
    jspb.Message.getWrapperField(this, Protos_common_pb.OrderResponse, 9));
};


/**
 * @param {?proto.common.OrderResponse|undefined} value
 * @return {!proto.order_transaction_endpoint.OrderTransaction} returns this
*/
proto.order_transaction_endpoint.OrderTransaction.prototype.setReferenceorder = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.OrderTransaction} returns this
 */
proto.order_transaction_endpoint.OrderTransaction.prototype.clearReferenceorder = function() {
  return this.setReferenceorder(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.OrderTransaction.prototype.hasReferenceorder = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional common.AccountResponse fromAccount = 10;
 * @return {?proto.common.AccountResponse}
 */
proto.order_transaction_endpoint.OrderTransaction.prototype.getFromaccount = function() {
  return /** @type{?proto.common.AccountResponse} */ (
    jspb.Message.getWrapperField(this, Protos_common_pb.AccountResponse, 10));
};


/**
 * @param {?proto.common.AccountResponse|undefined} value
 * @return {!proto.order_transaction_endpoint.OrderTransaction} returns this
*/
proto.order_transaction_endpoint.OrderTransaction.prototype.setFromaccount = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.OrderTransaction} returns this
 */
proto.order_transaction_endpoint.OrderTransaction.prototype.clearFromaccount = function() {
  return this.setFromaccount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.OrderTransaction.prototype.hasFromaccount = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional common.AccountResponse toAccount = 11;
 * @return {?proto.common.AccountResponse}
 */
proto.order_transaction_endpoint.OrderTransaction.prototype.getToaccount = function() {
  return /** @type{?proto.common.AccountResponse} */ (
    jspb.Message.getWrapperField(this, Protos_common_pb.AccountResponse, 11));
};


/**
 * @param {?proto.common.AccountResponse|undefined} value
 * @return {!proto.order_transaction_endpoint.OrderTransaction} returns this
*/
proto.order_transaction_endpoint.OrderTransaction.prototype.setToaccount = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.OrderTransaction} returns this
 */
proto.order_transaction_endpoint.OrderTransaction.prototype.clearToaccount = function() {
  return this.setToaccount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.OrderTransaction.prototype.hasToaccount = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional common.TransactionResponse matchTransaction = 12;
 * @return {?proto.common.TransactionResponse}
 */
proto.order_transaction_endpoint.OrderTransaction.prototype.getMatchtransaction = function() {
  return /** @type{?proto.common.TransactionResponse} */ (
    jspb.Message.getWrapperField(this, Protos_common_pb.TransactionResponse, 12));
};


/**
 * @param {?proto.common.TransactionResponse|undefined} value
 * @return {!proto.order_transaction_endpoint.OrderTransaction} returns this
*/
proto.order_transaction_endpoint.OrderTransaction.prototype.setMatchtransaction = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.OrderTransaction} returns this
 */
proto.order_transaction_endpoint.OrderTransaction.prototype.clearMatchtransaction = function() {
  return this.setMatchtransaction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.OrderTransaction.prototype.hasMatchtransaction = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional OrderTransactionStatus status = 13;
 * @return {?proto.order_transaction_endpoint.OrderTransactionStatus}
 */
proto.order_transaction_endpoint.OrderTransaction.prototype.getStatus = function() {
  return /** @type{?proto.order_transaction_endpoint.OrderTransactionStatus} */ (
    jspb.Message.getWrapperField(this, proto.order_transaction_endpoint.OrderTransactionStatus, 13));
};


/**
 * @param {?proto.order_transaction_endpoint.OrderTransactionStatus|undefined} value
 * @return {!proto.order_transaction_endpoint.OrderTransaction} returns this
*/
proto.order_transaction_endpoint.OrderTransaction.prototype.setStatus = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.OrderTransaction} returns this
 */
proto.order_transaction_endpoint.OrderTransaction.prototype.clearStatus = function() {
  return this.setStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.OrderTransaction.prototype.hasStatus = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * repeated common.ExtraField extraFields = 14;
 * @return {!Array<!proto.common.ExtraField>}
 */
proto.order_transaction_endpoint.OrderTransaction.prototype.getExtrafieldsList = function() {
  return /** @type{!Array<!proto.common.ExtraField>} */ (
    jspb.Message.getRepeatedWrapperField(this, Protos_common_pb.ExtraField, 14));
};


/**
 * @param {!Array<!proto.common.ExtraField>} value
 * @return {!proto.order_transaction_endpoint.OrderTransaction} returns this
*/
proto.order_transaction_endpoint.OrderTransaction.prototype.setExtrafieldsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 14, value);
};


/**
 * @param {!proto.common.ExtraField=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.ExtraField}
 */
proto.order_transaction_endpoint.OrderTransaction.prototype.addExtrafields = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 14, opt_value, proto.common.ExtraField, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.order_transaction_endpoint.OrderTransaction} returns this
 */
proto.order_transaction_endpoint.OrderTransaction.prototype.clearExtrafieldsList = function() {
  return this.setExtrafieldsList([]);
};


/**
 * optional common.OrderItemResponse tradedItem = 15;
 * @return {?proto.common.OrderItemResponse}
 */
proto.order_transaction_endpoint.OrderTransaction.prototype.getTradeditem = function() {
  return /** @type{?proto.common.OrderItemResponse} */ (
    jspb.Message.getWrapperField(this, Protos_common_pb.OrderItemResponse, 15));
};


/**
 * @param {?proto.common.OrderItemResponse|undefined} value
 * @return {!proto.order_transaction_endpoint.OrderTransaction} returns this
*/
proto.order_transaction_endpoint.OrderTransaction.prototype.setTradeditem = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.OrderTransaction} returns this
 */
proto.order_transaction_endpoint.OrderTransaction.prototype.clearTradeditem = function() {
  return this.setTradeditem(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.OrderTransaction.prototype.hasTradeditem = function() {
  return jspb.Message.getField(this, 15) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.order_transaction_endpoint.GetOrderTransactionsReplay.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.order_transaction_endpoint.GetOrderTransactionsReplay.prototype.toObject = function(opt_includeInstance) {
  return proto.order_transaction_endpoint.GetOrderTransactionsReplay.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.order_transaction_endpoint.GetOrderTransactionsReplay} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_transaction_endpoint.GetOrderTransactionsReplay.toObject = function(includeInstance, msg) {
  var f, obj = {
ordertransactionsList: jspb.Message.toObjectList(msg.getOrdertransactionsList(),
    proto.order_transaction_endpoint.OrderTransaction.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionsReplay}
 */
proto.order_transaction_endpoint.GetOrderTransactionsReplay.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.order_transaction_endpoint.GetOrderTransactionsReplay;
  return proto.order_transaction_endpoint.GetOrderTransactionsReplay.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.order_transaction_endpoint.GetOrderTransactionsReplay} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionsReplay}
 */
proto.order_transaction_endpoint.GetOrderTransactionsReplay.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.order_transaction_endpoint.OrderTransaction;
      reader.readMessage(value,proto.order_transaction_endpoint.OrderTransaction.deserializeBinaryFromReader);
      msg.addOrdertransactions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.order_transaction_endpoint.GetOrderTransactionsReplay.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.order_transaction_endpoint.GetOrderTransactionsReplay.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.order_transaction_endpoint.GetOrderTransactionsReplay} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_transaction_endpoint.GetOrderTransactionsReplay.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrdertransactionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.order_transaction_endpoint.OrderTransaction.serializeBinaryToWriter
    );
  }
};


/**
 * repeated OrderTransaction orderTransactions = 1;
 * @return {!Array<!proto.order_transaction_endpoint.OrderTransaction>}
 */
proto.order_transaction_endpoint.GetOrderTransactionsReplay.prototype.getOrdertransactionsList = function() {
  return /** @type{!Array<!proto.order_transaction_endpoint.OrderTransaction>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.order_transaction_endpoint.OrderTransaction, 1));
};


/**
 * @param {!Array<!proto.order_transaction_endpoint.OrderTransaction>} value
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionsReplay} returns this
*/
proto.order_transaction_endpoint.GetOrderTransactionsReplay.prototype.setOrdertransactionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.order_transaction_endpoint.OrderTransaction=} opt_value
 * @param {number=} opt_index
 * @return {!proto.order_transaction_endpoint.OrderTransaction}
 */
proto.order_transaction_endpoint.GetOrderTransactionsReplay.prototype.addOrdertransactions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.order_transaction_endpoint.OrderTransaction, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionsReplay} returns this
 */
proto.order_transaction_endpoint.GetOrderTransactionsReplay.prototype.clearOrdertransactionsList = function() {
  return this.setOrdertransactionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.order_transaction_endpoint.UpdateOrderTransactionReplay.prototype.toObject = function(opt_includeInstance) {
  return proto.order_transaction_endpoint.UpdateOrderTransactionReplay.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.order_transaction_endpoint.UpdateOrderTransactionReplay} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_transaction_endpoint.UpdateOrderTransactionReplay.toObject = function(includeInstance, msg) {
  var f, obj = {
updateddate: (f = msg.getUpdateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
message: (f = msg.getMessage()) && Protos_common_pb.MessageResponse.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.order_transaction_endpoint.UpdateOrderTransactionReplay}
 */
proto.order_transaction_endpoint.UpdateOrderTransactionReplay.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.order_transaction_endpoint.UpdateOrderTransactionReplay;
  return proto.order_transaction_endpoint.UpdateOrderTransactionReplay.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.order_transaction_endpoint.UpdateOrderTransactionReplay} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.order_transaction_endpoint.UpdateOrderTransactionReplay}
 */
proto.order_transaction_endpoint.UpdateOrderTransactionReplay.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateddate(value);
      break;
    case 2:
      var value = new Protos_common_pb.MessageResponse;
      reader.readMessage(value,Protos_common_pb.MessageResponse.deserializeBinaryFromReader);
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.order_transaction_endpoint.UpdateOrderTransactionReplay.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.order_transaction_endpoint.UpdateOrderTransactionReplay.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.order_transaction_endpoint.UpdateOrderTransactionReplay} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_transaction_endpoint.UpdateOrderTransactionReplay.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUpdateddate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getMessage();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      Protos_common_pb.MessageResponse.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp updatedDate = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.order_transaction_endpoint.UpdateOrderTransactionReplay.prototype.getUpdateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.order_transaction_endpoint.UpdateOrderTransactionReplay} returns this
*/
proto.order_transaction_endpoint.UpdateOrderTransactionReplay.prototype.setUpdateddate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.UpdateOrderTransactionReplay} returns this
 */
proto.order_transaction_endpoint.UpdateOrderTransactionReplay.prototype.clearUpdateddate = function() {
  return this.setUpdateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.UpdateOrderTransactionReplay.prototype.hasUpdateddate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional common.MessageResponse message = 2;
 * @return {?proto.common.MessageResponse}
 */
proto.order_transaction_endpoint.UpdateOrderTransactionReplay.prototype.getMessage = function() {
  return /** @type{?proto.common.MessageResponse} */ (
    jspb.Message.getWrapperField(this, Protos_common_pb.MessageResponse, 2));
};


/**
 * @param {?proto.common.MessageResponse|undefined} value
 * @return {!proto.order_transaction_endpoint.UpdateOrderTransactionReplay} returns this
*/
proto.order_transaction_endpoint.UpdateOrderTransactionReplay.prototype.setMessage = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.UpdateOrderTransactionReplay} returns this
 */
proto.order_transaction_endpoint.UpdateOrderTransactionReplay.prototype.clearMessage = function() {
  return this.setMessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.UpdateOrderTransactionReplay.prototype.hasMessage = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.order_transaction_endpoint.UpdateOrderTransactionStateReplay.prototype.toObject = function(opt_includeInstance) {
  return proto.order_transaction_endpoint.UpdateOrderTransactionStateReplay.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.order_transaction_endpoint.UpdateOrderTransactionStateReplay} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_transaction_endpoint.UpdateOrderTransactionStateReplay.toObject = function(includeInstance, msg) {
  var f, obj = {
updateddate: (f = msg.getUpdateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
message: (f = msg.getMessage()) && Protos_common_pb.MessageResponse.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.order_transaction_endpoint.UpdateOrderTransactionStateReplay}
 */
proto.order_transaction_endpoint.UpdateOrderTransactionStateReplay.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.order_transaction_endpoint.UpdateOrderTransactionStateReplay;
  return proto.order_transaction_endpoint.UpdateOrderTransactionStateReplay.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.order_transaction_endpoint.UpdateOrderTransactionStateReplay} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.order_transaction_endpoint.UpdateOrderTransactionStateReplay}
 */
proto.order_transaction_endpoint.UpdateOrderTransactionStateReplay.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateddate(value);
      break;
    case 2:
      var value = new Protos_common_pb.MessageResponse;
      reader.readMessage(value,Protos_common_pb.MessageResponse.deserializeBinaryFromReader);
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.order_transaction_endpoint.UpdateOrderTransactionStateReplay.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.order_transaction_endpoint.UpdateOrderTransactionStateReplay.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.order_transaction_endpoint.UpdateOrderTransactionStateReplay} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_transaction_endpoint.UpdateOrderTransactionStateReplay.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUpdateddate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getMessage();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      Protos_common_pb.MessageResponse.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp updatedDate = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.order_transaction_endpoint.UpdateOrderTransactionStateReplay.prototype.getUpdateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.order_transaction_endpoint.UpdateOrderTransactionStateReplay} returns this
*/
proto.order_transaction_endpoint.UpdateOrderTransactionStateReplay.prototype.setUpdateddate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.UpdateOrderTransactionStateReplay} returns this
 */
proto.order_transaction_endpoint.UpdateOrderTransactionStateReplay.prototype.clearUpdateddate = function() {
  return this.setUpdateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.UpdateOrderTransactionStateReplay.prototype.hasUpdateddate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional common.MessageResponse message = 2;
 * @return {?proto.common.MessageResponse}
 */
proto.order_transaction_endpoint.UpdateOrderTransactionStateReplay.prototype.getMessage = function() {
  return /** @type{?proto.common.MessageResponse} */ (
    jspb.Message.getWrapperField(this, Protos_common_pb.MessageResponse, 2));
};


/**
 * @param {?proto.common.MessageResponse|undefined} value
 * @return {!proto.order_transaction_endpoint.UpdateOrderTransactionStateReplay} returns this
*/
proto.order_transaction_endpoint.UpdateOrderTransactionStateReplay.prototype.setMessage = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.UpdateOrderTransactionStateReplay} returns this
 */
proto.order_transaction_endpoint.UpdateOrderTransactionStateReplay.prototype.clearMessage = function() {
  return this.setMessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.UpdateOrderTransactionStateReplay.prototype.hasMessage = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.order_transaction_endpoint.GetOrderTransactionsResponse.oneofGroups_ = [[1]];

/**
 * @enum {number}
 */
proto.order_transaction_endpoint.GetOrderTransactionsResponse.ResultCase = {
  RESULT_NOT_SET: 0,
  SUCCESS: 1
};

/**
 * @return {proto.order_transaction_endpoint.GetOrderTransactionsResponse.ResultCase}
 */
proto.order_transaction_endpoint.GetOrderTransactionsResponse.prototype.getResultCase = function() {
  return /** @type {proto.order_transaction_endpoint.GetOrderTransactionsResponse.ResultCase} */(jspb.Message.computeOneofCase(this, proto.order_transaction_endpoint.GetOrderTransactionsResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.order_transaction_endpoint.GetOrderTransactionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.order_transaction_endpoint.GetOrderTransactionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.order_transaction_endpoint.GetOrderTransactionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_transaction_endpoint.GetOrderTransactionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: (f = msg.getSuccess()) && proto.order_transaction_endpoint.GetOrderTransactionsReplay.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionsResponse}
 */
proto.order_transaction_endpoint.GetOrderTransactionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.order_transaction_endpoint.GetOrderTransactionsResponse;
  return proto.order_transaction_endpoint.GetOrderTransactionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.order_transaction_endpoint.GetOrderTransactionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionsResponse}
 */
proto.order_transaction_endpoint.GetOrderTransactionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.order_transaction_endpoint.GetOrderTransactionsReplay;
      reader.readMessage(value,proto.order_transaction_endpoint.GetOrderTransactionsReplay.deserializeBinaryFromReader);
      msg.setSuccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.order_transaction_endpoint.GetOrderTransactionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.order_transaction_endpoint.GetOrderTransactionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.order_transaction_endpoint.GetOrderTransactionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_transaction_endpoint.GetOrderTransactionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.order_transaction_endpoint.GetOrderTransactionsReplay.serializeBinaryToWriter
    );
  }
};


/**
 * optional GetOrderTransactionsReplay success = 1;
 * @return {?proto.order_transaction_endpoint.GetOrderTransactionsReplay}
 */
proto.order_transaction_endpoint.GetOrderTransactionsResponse.prototype.getSuccess = function() {
  return /** @type{?proto.order_transaction_endpoint.GetOrderTransactionsReplay} */ (
    jspb.Message.getWrapperField(this, proto.order_transaction_endpoint.GetOrderTransactionsReplay, 1));
};


/**
 * @param {?proto.order_transaction_endpoint.GetOrderTransactionsReplay|undefined} value
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionsResponse} returns this
*/
proto.order_transaction_endpoint.GetOrderTransactionsResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.order_transaction_endpoint.GetOrderTransactionsResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionsResponse} returns this
 */
proto.order_transaction_endpoint.GetOrderTransactionsResponse.prototype.clearSuccess = function() {
  return this.setSuccess(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.GetOrderTransactionsResponse.prototype.hasSuccess = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.order_transaction_endpoint.GetOrderTransactionResponse.oneofGroups_ = [[1]];

/**
 * @enum {number}
 */
proto.order_transaction_endpoint.GetOrderTransactionResponse.ResultCase = {
  RESULT_NOT_SET: 0,
  SUCCESS: 1
};

/**
 * @return {proto.order_transaction_endpoint.GetOrderTransactionResponse.ResultCase}
 */
proto.order_transaction_endpoint.GetOrderTransactionResponse.prototype.getResultCase = function() {
  return /** @type {proto.order_transaction_endpoint.GetOrderTransactionResponse.ResultCase} */(jspb.Message.computeOneofCase(this, proto.order_transaction_endpoint.GetOrderTransactionResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.order_transaction_endpoint.GetOrderTransactionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.order_transaction_endpoint.GetOrderTransactionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.order_transaction_endpoint.GetOrderTransactionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_transaction_endpoint.GetOrderTransactionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: (f = msg.getSuccess()) && proto.order_transaction_endpoint.GetOrderTransactionReplay.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionResponse}
 */
proto.order_transaction_endpoint.GetOrderTransactionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.order_transaction_endpoint.GetOrderTransactionResponse;
  return proto.order_transaction_endpoint.GetOrderTransactionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.order_transaction_endpoint.GetOrderTransactionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionResponse}
 */
proto.order_transaction_endpoint.GetOrderTransactionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.order_transaction_endpoint.GetOrderTransactionReplay;
      reader.readMessage(value,proto.order_transaction_endpoint.GetOrderTransactionReplay.deserializeBinaryFromReader);
      msg.setSuccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.order_transaction_endpoint.GetOrderTransactionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.order_transaction_endpoint.GetOrderTransactionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.order_transaction_endpoint.GetOrderTransactionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_transaction_endpoint.GetOrderTransactionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.order_transaction_endpoint.GetOrderTransactionReplay.serializeBinaryToWriter
    );
  }
};


/**
 * optional GetOrderTransactionReplay success = 1;
 * @return {?proto.order_transaction_endpoint.GetOrderTransactionReplay}
 */
proto.order_transaction_endpoint.GetOrderTransactionResponse.prototype.getSuccess = function() {
  return /** @type{?proto.order_transaction_endpoint.GetOrderTransactionReplay} */ (
    jspb.Message.getWrapperField(this, proto.order_transaction_endpoint.GetOrderTransactionReplay, 1));
};


/**
 * @param {?proto.order_transaction_endpoint.GetOrderTransactionReplay|undefined} value
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionResponse} returns this
*/
proto.order_transaction_endpoint.GetOrderTransactionResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.order_transaction_endpoint.GetOrderTransactionResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.GetOrderTransactionResponse} returns this
 */
proto.order_transaction_endpoint.GetOrderTransactionResponse.prototype.clearSuccess = function() {
  return this.setSuccess(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.GetOrderTransactionResponse.prototype.hasSuccess = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.order_transaction_endpoint.UpdateOrderTransactionResponse.oneofGroups_ = [[1]];

/**
 * @enum {number}
 */
proto.order_transaction_endpoint.UpdateOrderTransactionResponse.ResultCase = {
  RESULT_NOT_SET: 0,
  SUCCESS: 1
};

/**
 * @return {proto.order_transaction_endpoint.UpdateOrderTransactionResponse.ResultCase}
 */
proto.order_transaction_endpoint.UpdateOrderTransactionResponse.prototype.getResultCase = function() {
  return /** @type {proto.order_transaction_endpoint.UpdateOrderTransactionResponse.ResultCase} */(jspb.Message.computeOneofCase(this, proto.order_transaction_endpoint.UpdateOrderTransactionResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.order_transaction_endpoint.UpdateOrderTransactionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.order_transaction_endpoint.UpdateOrderTransactionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.order_transaction_endpoint.UpdateOrderTransactionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_transaction_endpoint.UpdateOrderTransactionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: (f = msg.getSuccess()) && proto.order_transaction_endpoint.UpdateOrderTransactionReplay.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.order_transaction_endpoint.UpdateOrderTransactionResponse}
 */
proto.order_transaction_endpoint.UpdateOrderTransactionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.order_transaction_endpoint.UpdateOrderTransactionResponse;
  return proto.order_transaction_endpoint.UpdateOrderTransactionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.order_transaction_endpoint.UpdateOrderTransactionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.order_transaction_endpoint.UpdateOrderTransactionResponse}
 */
proto.order_transaction_endpoint.UpdateOrderTransactionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.order_transaction_endpoint.UpdateOrderTransactionReplay;
      reader.readMessage(value,proto.order_transaction_endpoint.UpdateOrderTransactionReplay.deserializeBinaryFromReader);
      msg.setSuccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.order_transaction_endpoint.UpdateOrderTransactionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.order_transaction_endpoint.UpdateOrderTransactionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.order_transaction_endpoint.UpdateOrderTransactionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_transaction_endpoint.UpdateOrderTransactionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.order_transaction_endpoint.UpdateOrderTransactionReplay.serializeBinaryToWriter
    );
  }
};


/**
 * optional UpdateOrderTransactionReplay success = 1;
 * @return {?proto.order_transaction_endpoint.UpdateOrderTransactionReplay}
 */
proto.order_transaction_endpoint.UpdateOrderTransactionResponse.prototype.getSuccess = function() {
  return /** @type{?proto.order_transaction_endpoint.UpdateOrderTransactionReplay} */ (
    jspb.Message.getWrapperField(this, proto.order_transaction_endpoint.UpdateOrderTransactionReplay, 1));
};


/**
 * @param {?proto.order_transaction_endpoint.UpdateOrderTransactionReplay|undefined} value
 * @return {!proto.order_transaction_endpoint.UpdateOrderTransactionResponse} returns this
*/
proto.order_transaction_endpoint.UpdateOrderTransactionResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.order_transaction_endpoint.UpdateOrderTransactionResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.UpdateOrderTransactionResponse} returns this
 */
proto.order_transaction_endpoint.UpdateOrderTransactionResponse.prototype.clearSuccess = function() {
  return this.setSuccess(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.UpdateOrderTransactionResponse.prototype.hasSuccess = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.order_transaction_endpoint.UpdateOrderTransactionStateResponse.oneofGroups_ = [[1]];

/**
 * @enum {number}
 */
proto.order_transaction_endpoint.UpdateOrderTransactionStateResponse.ResultCase = {
  RESULT_NOT_SET: 0,
  SUCCESS: 1
};

/**
 * @return {proto.order_transaction_endpoint.UpdateOrderTransactionStateResponse.ResultCase}
 */
proto.order_transaction_endpoint.UpdateOrderTransactionStateResponse.prototype.getResultCase = function() {
  return /** @type {proto.order_transaction_endpoint.UpdateOrderTransactionStateResponse.ResultCase} */(jspb.Message.computeOneofCase(this, proto.order_transaction_endpoint.UpdateOrderTransactionStateResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.order_transaction_endpoint.UpdateOrderTransactionStateResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.order_transaction_endpoint.UpdateOrderTransactionStateResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.order_transaction_endpoint.UpdateOrderTransactionStateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_transaction_endpoint.UpdateOrderTransactionStateResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
success: (f = msg.getSuccess()) && proto.order_transaction_endpoint.UpdateOrderTransactionStateReplay.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.order_transaction_endpoint.UpdateOrderTransactionStateResponse}
 */
proto.order_transaction_endpoint.UpdateOrderTransactionStateResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.order_transaction_endpoint.UpdateOrderTransactionStateResponse;
  return proto.order_transaction_endpoint.UpdateOrderTransactionStateResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.order_transaction_endpoint.UpdateOrderTransactionStateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.order_transaction_endpoint.UpdateOrderTransactionStateResponse}
 */
proto.order_transaction_endpoint.UpdateOrderTransactionStateResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.order_transaction_endpoint.UpdateOrderTransactionStateReplay;
      reader.readMessage(value,proto.order_transaction_endpoint.UpdateOrderTransactionStateReplay.deserializeBinaryFromReader);
      msg.setSuccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.order_transaction_endpoint.UpdateOrderTransactionStateResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.order_transaction_endpoint.UpdateOrderTransactionStateResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.order_transaction_endpoint.UpdateOrderTransactionStateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.order_transaction_endpoint.UpdateOrderTransactionStateResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.order_transaction_endpoint.UpdateOrderTransactionStateReplay.serializeBinaryToWriter
    );
  }
};


/**
 * optional UpdateOrderTransactionStateReplay success = 1;
 * @return {?proto.order_transaction_endpoint.UpdateOrderTransactionStateReplay}
 */
proto.order_transaction_endpoint.UpdateOrderTransactionStateResponse.prototype.getSuccess = function() {
  return /** @type{?proto.order_transaction_endpoint.UpdateOrderTransactionStateReplay} */ (
    jspb.Message.getWrapperField(this, proto.order_transaction_endpoint.UpdateOrderTransactionStateReplay, 1));
};


/**
 * @param {?proto.order_transaction_endpoint.UpdateOrderTransactionStateReplay|undefined} value
 * @return {!proto.order_transaction_endpoint.UpdateOrderTransactionStateResponse} returns this
*/
proto.order_transaction_endpoint.UpdateOrderTransactionStateResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.order_transaction_endpoint.UpdateOrderTransactionStateResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.order_transaction_endpoint.UpdateOrderTransactionStateResponse} returns this
 */
proto.order_transaction_endpoint.UpdateOrderTransactionStateResponse.prototype.clearSuccess = function() {
  return this.setSuccess(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.order_transaction_endpoint.UpdateOrderTransactionStateResponse.prototype.hasSuccess = function() {
  return jspb.Message.getField(this, 1) != null;
};


goog.object.extend(exports, proto.order_transaction_endpoint);
